<template>
  <section class="section">
    <div class="content">
      <h1 class="title">
        Text Beautifier
      </h1>

      <p class="subtitle">
        "Quotes" become “smart quotes”; triple hyphen --- becomes —; triple ... becomes …, masonic dots .'. becomes ∴.
      </p>

      <p>
        <back-button />
      </p>
    </div>

    <div class="columns">
      <div class="column">
        <textarea class="textarea" v-model="ugly"></textarea>
      </div>

      <div class="column">
        <textarea class="textarea" v-model="beautiful" readonly></textarea>
      </div>
    </div>
  </section>
</template>

<script>
import BackButton from '@/components/pages/BackButton'

/* eslint-disable */
const smartquotes = function (input) {
  return input
      .replace(/'''/g, '\u2034')            // triple prime
      .replace(/(\W|^)"(\w)/g, '$1\u201c$2')                                       // beginning "
      .replace(/(\u201c[^"]*)"([^"]*$|[^\u201c"]*\u201c)/g, '$1\u201d$2')          // ending "
      .replace(/([^0-9])"/g,'$1\u201d')                                            // remaining " at end of word
      .replace(/''/g, '\u2033')                   // double prime as two single quotes
      .replace(/(\W|^)'(\S)/g, '$1\u2018$2')                                       // beginning '
      .replace(/([a-z])'([a-z])/ig, '$1\u2019$2')                                  // conjunction's possession
      .replace(/(\u2018)([0-9]{2}[^\u2019]*)(\u2018([^0-9]|$)|$|\u2019[a-z])/ig, '\u2019$2$3')     // abbrev. years like '93
      .replace(/((\u2018[^']*)|[a-z])'([^0-9]|$)/ig, '$1\u2019$3')                 // ending '
      .replace(/(\B|^)\u2018(?=([^\u2018\u2019]*\u2019\b)*([^\u2018\u2019]*\B\W[\u2018\u2019]\b|[^\u2018\u2019]*$))/ig, '$1\u2019') // backwards apostrophe
      .replace(/"/g, '\u2033')                                                     // double prime
      .replace(/'/g, '\u2032')
}

const hyphen = function (input) {
  return input
    .replace(/\s\-\s/g, ' – ')
    .replace(/\s\--\s/g, ' – ')
    .replace(/^\--\s/g, '– ')
    .replace(/\s\---\s/g, ' — ')
    .replace(/^\---\s/g, '— ')
    .replace(/\.\'\./g, '∴')
    .replace(/\.\`\./g, '∴')
    .replace(/\.\’\./g, '∴')
    .replace(/\.\‘\./g, '∴')
    .replace(/\.\:/g, '∴')
    .replace(/\:\./g, '∴')
    .replace(/\.\.\./g, '…')
}

const arrow = function (input) {
  return input
    .replace(/\-\>/g, '→')
    .replace(/\<\-/g, '←')
}

export default {
  components: {
    BackButton
  },
  data () {
    return {
      ugly: ''
    }
  },
  computed: {
    beautiful () {
      return hyphen(smartquotes(arrow(this.ugly)))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/TextBeautifierPage.vue